import { axiosInstanceWithCredentials } from "./base";

export function login(data) {
  return axiosInstanceWithCredentials.post("/administrator/login", data);
}
export function logout(data) {
  return axiosInstanceWithCredentials.post("/administrator/logoff", data);
}
export function keepAdminAlive() {
  return axiosInstanceWithCredentials.get("/keepalive");
}
export function isAuthenticated() {
  let authenticated = false;

  const isAuthenticated = localStorage.getItem("is_authenticated");

  if (isAuthenticated) {
    authenticated = true;
  } else {
    authenticated = false;
  }

  return authenticated;
}

export function setSession() {
  localStorage.setItem("is_authenticated", true);
}

export function removeSession() {
  localStorage.clear();
}
